export default "__VITE_ASSET__Bm1mfBS3__"